import React, {Fragment} from 'react';
import './Footer.css';

export default (props) => (
  <div className="footerWrapper">
    { props.showSteps && props.totalQuestions && props.totalQuestions.length > props.currentQuestion - 2 ?
      <div className="stepProgress">
        { props.totalQuestions.map( (q, i) => (
          <div className={`stepIcon ${ props.currentQuestion > i + 1 ? "stepIcon--done" : props.currentQuestion === i + 1 ? "stepIcon--current" : null }`} key={i}>
            <span
              className="stepNumber"
            >
              {i + 1}
            </span>
          </div>
        ))}
        <div className={`stepIcon ${ props.currentQuestion > 4 ? "stepIcon--done" : props.currentQuestion === 4 ? "stepIcon--current" : null }`} key={4}>
          <span
            className="stepNumber"
          >
            4
          </span>
        </div>
      </div>
    :
      <Fragment>
        <div className={`basket ${ props.showBasket ? "basketShow" : "" }`}>
          <h3 className="ttu fwb samplesLeft">
            <span className="badge">{2 - props.basket.length}</span> { props.basket.length === 1 ? "sample" : "samples"} left
          </h3>
          <div className="basketClose" onClick={ () => props.toggleBasketVisibility() }>&times;</div>
          <div className="selectedSamples">
            { props.basket && props.basket.length ?
              <div className="selectedWrapper">
                <div className="sample sampleAdded">
                  <img src={props.basket[0].fields.prodImgUrl} alt={props.basket[0].fields.name} />
                </div>
                <p>
                  {props.basket[0].fields.name}
                  <button
                    onClick={() => {
                      props.removeFromBasket(props.basket[0]);
                      props.trackEvent('Fragrance_Experience', `Removed from basket: ${props.basket[0].fields.name}`)
                    }}
                    className="delete"
                  >
                    &times;
                  </button>
                </p>
              </div>
            : null }
            { props.basket && props.basket.length > 1 ?
              <div className="selectedWrapper">
                <div className="sample sampleAdded">
                  <img src={props.basket[1].fields.prodImgUrl} alt={props.basket[1].fields.name} />
                </div>
                <p>
                  {props.basket[1].fields.name}
                  <button
                    onClick={() => {
                      props.removeFromBasket(props.basket[1]);                      
                      props.trackEvent('Fragrance_Experience', `Removed from basket: ${props.basket[1].fields.name}`)
                    }}
                    className="delete"
                  >
                    &times;
                  </button>
                </p>
              </div>
            : null }
          </div>
          <form
            action={`https://www.penhaligons.com/page/add_basket_api/?utm_source=${props.utm.source}&utm_campaign=${props.utm.campaign}&utm_medium=${props.utm.medium}&utm_term=${props.utm.term}&utm_content=${props.utm.content}`}
            method="post"
            id="checkoutForm"
            onSubmit={ 
              (e) => {
                e.preventDefault();
                props.trackEvent(
                  'Fragrance_Experience',
                  `Clicked Checkout - ${props.basket[0].fields.name} ${props.basket[1] ? "& " + props.basket[1].fields.name : ""}`,
                  'Clicked Checkout', 
                  {"products": `${props.basket[0].fields.name} & ${props.basket[1].fields.name}`}
                );
                setTimeout( () => document.getElementById("checkoutForm").submit(), 100);
              }
            }
          >
            { props.basket[0] && props.basket[1] ?
              <Fragment>
                <input name="skulist" value={`${props.basket[0].fields.sku}|${props.basket[1].fields.sku}`} type="hidden"/>
                <input name="qtylist" value={`1|1`} type="hidden"/>   
              </Fragment>                       
            : props.basket[0] ?
              <Fragment>
                <input name="skulist" value={`${props.basket[0].fields.sku}`} type="hidden"/>
                <input name="qtylist" value={`1`} type="hidden"/>      
              </Fragment>                    
            : null }
            { props.basket.length > 1 ?
              <button className="button button--dark">
                Checkout
              </button>
            :
              <Fragment>
                <div className="formTip">
                  <p>Select your two samples above to checkout</p>
                </div>
                <button disabled className="button button--dark">
                  Checkout
                </button>
              </Fragment>
            }
          </form>
        </div>
        <div className="basketToggle">
          { props.basket.length ? 
            <button className="button button--dark full" onClick={ () => props.toggleBasketVisibility() }>
              View Basket ({props.basket.length})
            </button>
          :
            <button className="button button--blank button--dark full">
              Select two samples
            </button>
          }
        </div>
      </Fragment>
    }
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js